import React from 'react'
import styles from '../Styles/styles.css'
export const Logo = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width="100%" viewBox="0 0 500 500" enable-background="new 0 0 500 500" xmlSpace="preserve">
  <path fill="transparent" opacity="1.000000" stroke="none"
    d="
M485.000000,1.000002 
C490.327454,1.000000 495.654938,1.000000 501.000000,1.000000 
C501.000000,128.020889 501.000000,255.041794 500.621460,382.739807 
C500.165039,404.592834 500.077820,425.768768 500.051300,446.944763 
C500.050446,447.629425 500.669769,448.314911 501.000000,449.000000 
C501.000000,449.444458 501.000000,449.888885 500.622772,450.879333 
C500.171570,460.446899 500.061279,469.468506 500.068146,478.490051 
C500.069061,479.660278 500.674561,480.830017 501.000000,482.000000 
C501.000000,482.000000 501.000000,482.500000 500.701569,482.788208 
C500.084534,483.483826 499.765930,483.891205 499.447327,484.298645 
C499.964905,484.532440 500.482452,484.766205 501.000000,485.000000 
C501.000000,490.328857 501.000000,495.657715 501.000000,500.993286 
C334.477661,501.000000 167.955338,501.000000 1.433014,500.997253 
C1.288676,500.997253 1.144338,500.955627 1.000000,500.933441 
C1.000000,496.270721 1.000000,491.608032 1.299180,486.433960 
C1.918249,485.514709 2.238139,485.106842 2.558026,484.698944 
C2.038682,484.465973 1.519338,484.233002 0.999998,484.000000 
C1.000000,478.977905 1.000000,473.955811 1.368334,468.243469 
C1.769345,454.028107 1.802021,440.502960 1.894777,426.513947 
C1.967122,419.887939 2.074472,413.723816 1.945692,407.564606 
C1.892857,405.037598 1.330552,402.521210 1.000000,400.000000 
C1.000000,267.066040 1.000000,134.132095 1.000000,1.000000 
C161.354172,1.000000 321.708435,1.000000 482.569641,1.298343 
C483.483948,1.915222 483.891266,2.233758 484.298584,2.552305 
C484.532410,2.034879 484.766205,1.517441 485.000000,1.000002 
M259.753235,399.950867 
C269.725983,399.057800 276.338348,388.822571 274.808929,379.648651 
C273.065674,369.192230 263.182159,362.641052 253.279526,365.085144 
C244.499481,367.252228 238.907913,374.476532 239.380219,383.043121 
C239.905884,392.577423 245.743027,398.581604 256.408051,400.594666 
C257.265778,400.448608 258.123505,400.302551 259.753235,399.950867 
M137.585159,180.353699 
C136.741806,180.438843 135.898453,180.524002 134.203278,180.810318 
C131.957458,181.137970 129.711639,181.465607 127.464729,181.793396 
C127.464729,184.763000 127.464699,187.241089 127.464745,189.719193 
C127.464981,203.288727 127.466835,216.858246 127.464020,230.427780 
C127.463524,232.821564 127.325264,235.126114 130.848602,235.203857 
C143.913239,235.492203 155.189087,226.988464 157.449570,214.312012 
C159.746567,201.430756 155.987549,183.667297 137.585159,180.353699 
M52.397705,415.276733 
C50.610832,415.423035 48.823956,415.569366 46.187843,415.923798 
C44.448368,415.848755 42.708897,415.773682 40.788975,415.450989 
C40.485184,415.275635 40.234592,415.346344 39.240463,415.889618 
C34.704956,415.627594 35.696712,417.935089 37.125847,420.441925 
C40.964054,427.174530 44.643776,434.003906 48.679077,440.616272 
C55.382931,451.601379 60.885872,462.578888 59.299782,476.325806 
C58.128956,486.473541 59.078850,486.583130 69.569405,487.727112 
C71.015694,487.626556 72.461975,487.526031 74.748283,487.188049 
C77.052849,487.210327 78.790550,487.091339 78.644882,483.777283 
C78.412010,478.479187 78.540352,473.129425 79.019585,467.847229 
C79.394867,463.710815 79.760361,459.277405 81.493263,455.622131 
C85.081818,448.052704 89.632950,440.943817 93.682404,433.587311 
C96.746887,428.020142 99.647270,422.362671 103.181824,415.685333 
C97.219101,415.685333 92.589539,415.685333 87.645088,415.347778 
C87.111137,415.455475 86.577179,415.563171 85.279861,415.862610 
C79.869980,415.871948 80.176331,420.810638 78.714668,423.906036 
C75.667015,430.360260 73.162262,437.070892 70.026459,444.664062 
C65.967430,435.489563 62.300022,427.606293 59.015392,419.566620 
C57.784626,416.554108 55.823822,415.656860 52.397705,415.276733 
M376.541565,248.168884 
C376.541565,248.168884 376.388031,248.551132 376.388031,248.551132 
C376.388031,248.551132 376.667389,248.868790 376.786102,249.659698 
C373.275513,260.996643 370.418610,272.588043 366.124329,283.619934 
C355.753174,310.263062 340.309723,333.751434 318.229034,352.092194 
C308.162354,360.453827 296.579163,367.067230 285.329590,373.889465 
C280.751740,376.665649 282.291809,380.141479 283.060272,383.249664 
C283.944489,386.826141 286.958893,385.843292 289.601990,384.755798 
C304.076294,378.800568 317.085724,370.415039 328.735504,360.103058 
C341.785004,348.552094 352.623444,335.051056 361.643311,320.100098 
C373.354431,300.688202 381.816772,279.959259 387.004761,257.906097 
C388.341797,252.222534 389.286133,246.446579 390.442383,240.552460 
C384.322601,241.585403 377.792572,240.164383 376.541565,248.168884 
M464.256012,487.572784 
C464.592682,487.691681 464.833282,487.572632 465.601807,486.751434 
C465.661987,485.944061 465.986847,485.045227 465.743958,484.342621 
C458.174530,462.445831 450.577393,440.558380 442.855164,418.715210 
C442.452209,417.575409 440.938293,416.070526 439.898285,416.035889 
C432.807343,415.799744 425.704742,415.912231 419.623138,415.912231 
C415.463287,428.382080 411.636627,439.955383 407.740021,451.505066 
C403.850372,463.034027 399.890656,474.539337 395.582733,487.165680 
C400.836090,487.165680 405.109222,486.956177 409.351654,487.227386 
C413.234039,487.475555 415.562408,486.527130 416.278168,482.229553 
C416.805817,479.061279 418.282959,476.051147 419.343597,472.951477 
C424.970886,472.951477 430.333160,473.349457 435.606323,472.834656 
C440.457001,472.361115 442.197327,474.366425 443.260254,478.734192 
C444.017914,481.847626 443.769562,485.967896 448.220093,487.547333 
C448.220093,487.547333 448.642731,487.608398 448.642731,487.608398 
C448.642731,487.608398 448.966187,487.295319 449.820557,487.095856 
C451.566620,487.175629 453.312683,487.255402 455.527985,487.717285 
C456.665588,487.589661 457.803162,487.462067 459.773132,487.117554 
C461.197418,487.191406 462.621674,487.265259 464.256012,487.572784 
M384.797272,487.216858 
C386.376892,487.086273 387.956512,486.955688 389.593872,486.820312 
C389.593872,462.985138 389.593872,439.662689 389.593872,415.884521 
C384.645752,415.884521 379.994476,416.205292 375.408783,415.794189 
C370.836975,415.384308 369.735535,417.079712 369.981079,421.409454 
C370.361206,428.112762 370.081360,434.853455 370.081360,441.592834 
C363.104340,441.592834 356.999817,441.592834 350.743744,441.373047 
C350.466888,441.231995 350.253510,441.305664 349.248199,441.766418 
C348.815521,440.214203 348.039917,438.668762 348.009277,437.108643 
C347.872986,430.179230 347.950165,423.245636 347.950165,415.917389 
C342.503571,415.917389 337.689667,416.146912 332.909668,415.843323 
C329.214691,415.608612 327.818878,416.758575 327.996796,420.554108 
C328.331604,427.697784 328.386627,434.858002 328.413696,442.011902 
C328.469513,456.760681 328.430481,471.509827 328.430481,487.084167 
C333.607849,487.084167 338.553406,486.821838 343.455322,487.171509 
C347.041992,487.427307 348.122131,486.294556 348.025665,482.764313 
C347.808899,474.832275 347.957703,466.890259 347.957703,459.048462 
C355.630981,459.048462 362.717102,459.048462 370.045258,459.048462 
C370.045258,467.108826 370.077942,474.904999 370.025024,482.700623 
C370.009491,484.993347 369.965546,487.145538 373.347504,487.665283 
C373.867004,487.595795 374.386505,487.526337 375.610077,487.235718 
C376.091492,487.264160 376.572906,487.292603 377.635895,487.736450 
C379.732422,487.618988 381.828979,487.501526 384.797272,487.216858 
M193.519104,487.707397 
C194.659683,487.583862 195.800262,487.460297 197.862686,487.121643 
C201.831253,486.976135 205.804169,486.904785 209.767609,486.672028 
C225.665924,485.738342 240.821762,475.977844 243.874344,457.962219 
C246.935745,439.894379 239.044662,421.528381 219.079865,417.898346 
C207.782532,415.844238 195.995758,416.421722 184.421707,416.062561 
C183.479919,416.033325 181.645660,417.913849 181.628677,418.930420 
C181.337143,436.377258 181.199631,453.827820 181.188492,471.277618 
C181.185181,476.472626 181.672440,481.667969 181.957932,487.318390 
C186.129715,487.318390 189.591553,487.318390 193.519104,487.707397 
M269.633881,487.123352 
C270.106995,487.194214 270.580139,487.265076 271.354095,487.665009 
C271.877655,487.579529 272.401215,487.494080 273.699036,487.205719 
C274.482239,487.255615 275.265411,487.305481 276.231415,487.586884 
C276.231415,487.586884 276.636719,487.642761 276.636719,487.642761 
C276.636719,487.642761 276.951782,487.352570 277.833466,487.093628 
C279.822113,486.942657 281.813965,486.825043 283.798920,486.635284 
C296.353607,485.435120 306.578369,480.142822 313.270142,469.185455 
C317.849091,461.687744 317.888550,453.206055 317.806213,444.183380 
C317.697754,443.815277 317.589294,443.447205 317.165710,442.342621 
C315.074890,437.900146 313.583984,433.029022 310.775970,429.098938 
C303.558044,418.996796 292.373230,416.903229 280.786865,415.435333 
C280.493347,415.261414 280.247894,415.325623 279.128845,415.841705 
C271.225342,415.841705 263.321808,415.841705 255.295044,415.841705 
C255.176758,417.137115 255.073090,417.768646 255.067978,418.400970 
C254.892197,440.105896 254.665237,461.810974 254.709381,483.515533 
C254.711990,484.806641 256.899475,486.093323 258.476715,487.727173 
C259.294250,487.612091 260.111816,487.497040 261.636566,487.203064 
C262.115479,487.262573 262.594421,487.322113 263.640900,487.762970 
C265.407288,487.620544 267.173645,487.478088 269.633881,487.123352 
M125.651848,181.750443 
C125.778625,181.470505 125.708572,181.239380 125.211937,180.164474 
C125.456985,176.038681 125.848755,171.915527 125.923363,167.786652 
C126.425575,139.995468 136.366547,115.520470 152.212112,93.168640 
C153.283997,91.656631 155.545792,90.832802 157.410751,90.073364 
C160.521790,88.806503 164.153778,88.438507 166.852905,86.628212 
C171.061783,83.805336 174.667084,80.084793 178.540115,76.758568 
C206.369019,52.858696 238.396408,44.592060 274.279449,51.512398 
C296.539581,55.805447 315.007874,67.233559 330.978790,83.022209 
C334.663361,86.664726 338.732300,89.382019 344.158295,90.262123 
C346.739288,90.680763 349.636230,92.699928 351.265808,94.847237 
C360.338531,106.802322 367.452759,119.988724 371.227325,134.476776 
C373.990265,145.081894 374.836456,156.186401 376.342773,167.266556 
C376.233337,167.558304 376.321014,167.786530 376.793060,168.878113 
C376.793060,191.404449 376.793060,213.930801 376.793060,235.950775 
C384.944794,238.916290 393.307159,230.780670 394.069550,224.378586 
C394.577454,220.113480 394.793274,215.793610 394.827606,211.495758 
C394.940369,197.387405 394.910492,183.277893 394.958832,168.593002 
C394.753448,168.075821 394.548065,167.558624 394.148865,166.151489 
C393.754059,162.859131 393.303192,159.572388 392.973267,156.273544 
C390.330963,129.853867 380.709076,106.068008 365.623322,84.413719 
C363.074036,80.754425 361.852020,77.131973 361.383392,72.646027 
C360.949310,68.490341 359.394531,63.643341 356.629913,60.701405 
C350.114319,53.767845 343.122772,47.024349 335.371552,41.552929 
C298.751617,15.703630 258.464355,8.230787 214.889709,18.972660 
C189.581390,25.211582 168.102234,38.183300 149.501205,56.239777 
C144.348190,61.241936 140.861130,66.908592 140.282120,74.255295 
C140.074921,76.884331 139.754517,79.904510 138.348221,81.972664 
C130.471008,93.557297 123.700401,105.712265 118.787926,118.820320 
C113.666779,132.485199 109.688721,146.469086 109.105713,161.189407 
C108.579613,174.472610 108.128395,187.758804 107.414307,201.241943 
C107.277885,201.558823 107.373863,201.801025 107.924820,202.886368 
C107.995125,209.377243 107.795456,215.884979 108.199570,222.355011 
C108.792381,231.846039 115.926254,237.689346 124.710632,236.321686 
C124.937195,234.527206 125.163750,232.732712 125.730148,230.525955 
C125.617142,229.705017 125.504135,228.884064 125.174118,227.180893 
C125.246941,224.766129 125.319756,222.351364 125.745926,219.459854 
C125.637794,218.330826 125.529655,217.201813 125.220352,215.145981 
C125.286858,206.407928 125.353363,197.669891 125.761124,188.446457 
C125.642746,187.319183 125.524376,186.191895 125.174866,184.298599 
C125.267685,183.512070 125.360504,182.725555 125.651848,181.750443 
M147.197952,243.849380 
C147.361084,244.218826 147.524216,244.588257 148.063019,245.761169 
C149.580292,256.188721 151.097565,266.616302 152.394119,277.237732 
C152.254211,277.539520 152.335907,277.780609 152.879105,278.640198 
C152.804886,279.108337 152.730667,279.576447 152.423920,280.253967 
C152.303070,280.588165 152.419098,280.829437 153.055695,281.810730 
C153.353149,284.437500 154.153900,287.125122 153.845001,289.678558 
C153.167114,295.282135 155.655380,299.245911 159.501266,302.726318 
C161.820267,304.824951 164.209778,306.845734 166.569778,308.898987 
C179.657959,320.286163 192.779770,331.634979 205.820816,343.075867 
C211.899506,348.408691 217.755875,353.996063 223.872711,359.283264 
C225.061401,360.310730 226.988968,360.483398 228.575729,361.050354 
C229.088425,359.180573 229.617462,357.315002 230.102386,355.438049 
C230.224045,354.967194 230.204041,354.459717 230.511612,353.771393 
C230.666306,353.427765 230.555206,353.176575 229.949814,352.168488 
C229.104904,345.669495 228.240265,339.172974 227.420486,332.670807 
C226.561935,325.861115 225.746475,319.046021 224.865952,311.787659 
C224.788712,311.487061 224.629059,311.239685 224.157730,310.176392 
C223.048523,300.491241 222.009781,290.797302 220.801987,281.124451 
C220.144302,275.857361 218.604965,271.052887 214.408417,267.204590 
C202.824493,256.581940 191.319061,245.864441 180.071426,234.888458 
C174.895508,229.837524 172.921753,223.294846 174.732117,216.001709 
C175.455032,216.000931 176.177933,216.000137 177.563904,216.217361 
C178.022293,216.412094 178.519104,216.546448 178.933502,216.810257 
C194.891464,226.969254 211.784607,235.036285 230.057678,240.171127 
C234.897171,241.531052 237.798309,245.055237 238.204025,250.830353 
C238.330643,251.199081 238.457260,251.567810 238.845932,252.841766 
C239.207687,256.973511 239.934509,261.112274 239.855072,265.235504 
C239.690475,273.775604 240.220886,282.554260 238.413467,290.784149 
C235.789276,302.733032 235.018555,302.559235 244.400070,310.313904 
C245.680801,311.372559 246.749893,312.928741 248.207886,313.467957 
C249.884720,314.088104 252.376358,314.630371 253.668411,313.834137 
C265.454865,306.571014 266.583191,303.476349 263.200348,289.929413 
C262.998871,289.122620 262.815033,288.310577 262.652618,287.495056 
C260.479980,276.586121 261.994324,265.763672 263.750671,254.499939 
C263.819672,253.962234 263.888672,253.424530 263.912628,252.098434 
C263.732452,245.059860 267.354462,241.940109 273.986389,239.621109 
C286.045074,235.404510 297.724823,230.021057 309.331329,224.626633 
C315.957428,221.546997 322.126434,217.483948 329.077271,213.536591 
C329.252075,222.559769 326.908936,230.046539 320.782410,235.965775 
C310.577362,245.825562 300.188507,255.495743 289.835846,265.201782 
C285.614868,269.159119 282.497314,273.559692 281.832977,279.590607 
C280.602509,290.760956 279.044769,301.895294 277.317078,313.380737 
C277.153015,313.648102 277.079254,313.938446 277.166229,315.106628 
C276.990814,317.248260 276.897552,319.400391 276.626282,321.529816 
C275.144806,333.158081 273.558563,344.773560 272.186676,356.414459 
C272.015198,357.869476 272.897766,359.448669 273.291931,360.970306 
C274.947968,360.483337 276.981598,360.448212 278.196350,359.433136 
C284.275909,354.352997 290.104858,348.974548 296.089050,343.778320 
C307.375885,333.977722 318.734772,324.260071 330.009705,314.445892 
C334.613586,310.438446 339.052582,306.242188 343.610077,302.180664 
C349.831573,296.636230 348.093933,288.907135 349.709290,281.342499 
C349.703888,280.300568 349.698517,279.258667 349.661987,277.439423 
C350.226624,273.280090 350.791290,269.120728 351.669250,264.646088 
C351.842041,264.392792 351.927887,264.112854 351.836761,262.972900 
C352.318268,259.970917 352.799744,256.968964 353.646332,253.481476 
C353.674438,253.082428 353.702545,252.683380 353.758881,251.470520 
C353.781830,251.138565 353.775848,250.801636 353.831940,250.475388 
C354.941711,244.021637 354.036407,239.521698 347.946594,234.529495 
C334.756470,223.716736 333.392883,208.640259 338.490784,192.983551 
C342.172729,181.675613 350.864655,171.230240 367.524719,173.108154 
C364.915405,112.746071 306.717865,63.237595 259.027191,62.338539 
C263.742188,84.815567 278.465179,95.226593 300.734100,96.851501 
C299.298737,100.476341 298.192108,103.400566 296.990112,106.285080 
C290.382294,122.142151 283.794312,138.007690 277.113464,153.834000 
C272.435822,164.914795 267.620453,175.937454 262.465027,186.730713 
C262.224304,186.510117 262.059509,186.242722 261.926178,185.171112 
C269.899994,158.662903 277.873840,132.154694 285.982178,105.199265 
C269.262115,100.948235 258.352875,89.951126 250.943954,73.683167 
C244.373093,90.996429 232.560059,100.501068 216.597321,105.275497 
C223.847900,129.496048 230.942917,153.196884 238.025772,177.450912 
C238.223190,177.948593 238.420624,178.446274 238.960922,179.678909 
C239.559372,181.729614 240.157806,183.780319 239.952103,185.917130 
C239.683807,185.943298 239.415497,185.969482 238.611618,185.488159 
C226.312790,156.084396 214.013947,126.680641 201.511581,96.790306 
C211.851624,95.807381 221.351242,93.949944 229.220840,87.410812 
C237.119537,80.847511 241.315720,72.317284 243.699432,61.528358 
C210.327484,65.490288 184.511993,81.677490 162.883774,105.009407 
C145.253876,124.028069 136.922516,147.293610 134.471390,173.103638 
C154.258652,170.809448 164.290146,188.008209 165.424194,204.225281 
C165.267776,204.530930 165.346680,204.776810 165.865173,205.835281 
C165.675354,219.344376 161.671829,230.879791 149.528656,238.490112 
C148.282013,239.271408 148.014450,241.614899 147.197952,243.849380 
M157.219254,481.807495 
C169.967041,472.132233 174.690445,455.094086 168.870453,437.397827 
C164.728806,424.804810 155.458206,417.172852 142.487625,415.369690 
C129.634232,413.582825 117.798370,416.359253 109.109146,427.274872 
C102.050354,436.142303 100.513634,446.269928 101.635284,457.171844 
C102.598785,466.536591 105.605278,475.187042 113.376427,480.694855 
C127.215103,490.503082 141.888382,491.047668 157.219254,481.807495 
M350.528809,188.034729 
C349.208832,190.303879 347.609406,192.457733 346.617493,194.862228 
C342.417725,205.042877 343.132751,221.651596 351.652069,228.128708 
C358.250214,233.145157 365.648132,235.221848 374.014282,235.063614 
C374.014282,217.124619 374.014282,199.331451 374.014282,181.650772 
C362.677429,179.905304 357.879395,181.158447 350.528809,188.034729 
M7.191591,492.799988 
C7.039694,492.756958 6.881521,492.666351 6.737805,492.685303 
C6.613637,492.701691 6.505909,492.842590 6.390926,492.928467 
C7.182291,493.926361 7.973654,494.924286 8.765018,495.922180 
C9.013636,495.679688 9.262254,495.437195 9.510871,495.194702 
C8.885415,494.512787 8.259959,493.830841 7.191591,492.799988 
M497.432953,490.589142 
C497.683319,489.915009 497.933716,489.240906 498.184082,488.566772 
C497.925018,488.482544 497.665985,488.398285 497.406921,488.314026 
C497.244415,489.097473 497.081909,489.880890 497.432953,490.589142 
M493.394562,495.589081 
C493.045959,495.610199 492.697388,495.631317 492.348785,495.652496 
C492.420837,495.902283 492.492859,496.152039 492.564911,496.401855 
C492.806549,496.270599 493.048187,496.139343 493.394562,495.589081 
M494.628174,493.475891 
C494.840302,493.530518 495.052399,493.585144 495.264526,493.639771 
C495.128052,493.505035 494.991577,493.370300 494.628174,493.475891 
z"/>
  <path fill="#6D6C6B" opacity="1.000000" stroke="none"
    d="
M501.000000,448.531342 
C500.669769,448.314911 500.050446,447.629425 500.051300,446.944763 
C500.077820,425.768768 500.165039,404.592834 500.621460,383.208435 
C501.000000,404.687561 501.000000,426.375122 501.000000,448.531342 
z"/>
  <path fill="#5C524F" opacity="1.000000" stroke="none"
    d="
M1.834698,426.977814 
C1.802021,440.502960 1.769345,454.028107 1.368334,467.776611 
C1.000000,454.645782 1.000000,441.291534 1.208637,427.461670 
C1.417273,426.986053 1.834698,426.977814 1.834698,426.977814 
z"/>
  <path fill="#656160" opacity="1.000000" stroke="none"
    d="
M501.000000,481.531342 
C500.674561,480.830017 500.069061,479.660278 500.068146,478.490051 
C500.061279,469.468506 500.171570,460.446899 500.622772,451.212646 
C501.000000,461.020905 501.000000,471.041779 501.000000,481.531342 
z"/>
  <path fill="#656160" opacity="1.000000" stroke="none"
    d="
M1.894777,426.513947 
C1.834698,426.977814 1.417273,426.986053 1.208637,426.993042 
C1.000000,418.312439 1.000000,409.624878 1.000000,400.468658 
C1.330552,402.521210 1.892857,405.037598 1.945692,407.564606 
C2.074472,413.723816 1.967122,419.887939 1.894777,426.513947 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M484.666687,1.000002 
C484.766205,1.517441 484.532410,2.034879 484.298584,2.552305 
C483.891266,2.233758 483.483948,1.915222 483.038300,1.298343 
C483.444458,1.000000 483.888885,1.000000 484.666687,1.000002 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M501.000000,484.666687 
C500.482452,484.766205 499.964905,484.532440 499.447327,484.298645 
C499.765930,483.891205 500.084534,483.483826 500.701569,483.038208 
C501.000000,483.444458 501.000000,483.888885 501.000000,484.666687 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M0.999998,484.333313 
C1.519338,484.233002 2.038682,484.465973 2.558026,484.698944 
C2.238139,485.106842 1.918249,485.514709 1.299180,485.961304 
C1.000000,485.555542 1.000000,485.111115 0.999998,484.333313 
z"/>
  <path fill="#FCFCFC" opacity="1.000000" stroke="none"
    d="
M152.614838,277.043854 
C151.097565,266.616302 149.580292,256.188721 147.889008,245.051086 
C147.574188,243.971832 147.433380,243.602661 147.292572,243.233490 
C148.014450,241.614899 148.282013,239.271408 149.528656,238.490112 
C161.671829,230.879791 165.675354,219.344376 165.859375,205.167542 
C165.788925,204.345566 165.724258,204.191330 165.659607,204.037094 
C164.290146,188.008209 154.258652,170.809448 134.471390,173.103638 
C136.922516,147.293610 145.253876,124.028069 162.883774,105.009407 
C184.511993,81.677490 210.327484,65.490288 243.699432,61.528358 
C241.315720,72.317284 237.119537,80.847511 229.220840,87.410812 
C221.351242,93.949944 211.851624,95.807381 201.511581,96.790306 
C214.013947,126.680641 226.312790,156.084396 238.879181,186.109985 
C239.571426,187.797180 239.996140,188.862564 240.420837,189.927948 
C240.707794,189.861740 240.994751,189.795532 241.281708,189.729324 
C241.106552,188.429901 240.931396,187.130463 240.756241,185.831024 
C240.157806,183.780319 239.559372,181.729614 238.884445,179.031723 
C238.551285,177.888947 238.294601,177.393341 238.037933,176.897736 
C230.942917,153.196884 223.847900,129.496048 216.597321,105.275497 
C232.560059,100.501068 244.373093,90.996429 250.943954,73.683167 
C258.352875,89.951126 269.262115,100.948235 285.982178,105.199265 
C277.873840,132.154694 269.899994,158.662903 261.672668,185.763367 
C260.971497,187.479721 260.523865,188.603836 260.076233,189.727951 
C260.484131,189.912399 260.891998,190.096848 261.299866,190.281296 
C261.822113,189.182877 262.344360,188.084473 262.866608,186.986069 
C267.620453,175.937454 272.435822,164.914795 277.113464,153.834000 
C283.794312,138.007690 290.382294,122.142151 296.990112,106.285080 
C298.192108,103.400566 299.298737,100.476341 300.734100,96.851501 
C278.465179,95.226593 263.742188,84.815567 259.027191,62.338539 
C306.717865,63.237595 364.915405,112.746071 367.524719,173.108154 
C350.864655,171.230240 342.172729,181.675613 338.490784,192.983551 
C333.392883,208.640259 334.756470,223.716736 347.946594,234.529495 
C354.036407,239.521698 354.941711,244.021637 353.831940,250.475388 
C353.775848,250.801636 353.781830,251.138565 353.506897,252.096466 
C353.263672,253.137268 353.272461,253.552124 353.281250,253.966980 
C352.799744,256.968964 352.318268,259.970917 351.659119,263.510986 
C351.439636,264.353180 351.397797,264.657288 351.355957,264.961395 
C350.791290,269.120728 350.226624,273.280090 349.435516,278.139954 
C349.219238,279.882690 349.229462,280.924927 349.239655,281.967133 
C348.093933,288.907135 349.831573,296.636230 343.610077,302.180664 
C339.052582,306.242188 334.613586,310.438446 330.009705,314.445892 
C318.734772,324.260071 307.375885,333.977722 296.089050,343.778320 
C290.104858,348.974548 284.275909,354.352997 278.196350,359.433136 
C276.981598,360.448212 274.947968,360.483337 273.291931,360.970337 
C272.897766,359.448669 272.015198,357.869476 272.186676,356.414459 
C273.558563,344.773560 275.144806,333.158081 276.626282,321.529816 
C276.897552,319.400391 276.990814,317.248260 277.357269,314.549194 
C277.573334,313.676056 277.598328,313.360321 277.623352,313.044617 
C279.044769,301.895294 280.602509,290.760956 281.832977,279.590607 
C282.497314,273.559692 285.614868,269.159119 289.835846,265.201782 
C300.188507,255.495743 310.577362,245.825562 320.782410,235.965775 
C326.908936,230.046539 329.252075,222.559769 329.077271,213.536591 
C322.126434,217.483948 315.957428,221.546997 309.331329,224.626633 
C297.724823,230.021057 286.045074,235.404510 273.986389,239.621109 
C267.354462,241.940109 263.732452,245.059860 263.681274,252.653900 
C263.441406,253.786087 263.432892,254.362793 263.424347,254.939514 
C261.994324,265.763672 260.479980,276.586121 262.652618,287.495056 
C262.815033,288.310577 262.998871,289.122620 263.200348,289.929413 
C266.583191,303.476349 265.454865,306.571014 253.668411,313.834137 
C252.376358,314.630371 249.884720,314.088104 248.207886,313.467957 
C246.749893,312.928741 245.680801,311.372559 244.400070,310.313904 
C235.018555,302.559235 235.789276,302.733032 238.413467,290.784149 
C240.220886,282.554260 239.690475,273.775604 239.855072,265.235504 
C239.934509,261.112274 239.207687,256.973511 238.823456,252.092468 
C238.641663,250.976761 238.482361,250.610336 238.323044,250.243912 
C237.798309,245.055237 234.897171,241.531052 230.057678,240.171127 
C211.784607,235.036285 194.891464,226.969254 178.933502,216.810257 
C178.519104,216.546448 178.022293,216.412094 177.112457,215.810135 
C175.776871,215.601944 174.892731,215.800980 174.008591,216.000015 
C172.921753,223.294846 174.895508,229.837524 180.071426,234.888458 
C191.319061,245.864441 202.824493,256.581940 214.408417,267.204590 
C218.604965,271.052887 220.144302,275.857361 220.801987,281.124451 
C222.009781,290.797302 223.048523,300.491241 224.184723,310.852905 
C224.445221,311.764008 224.678711,311.998627 224.912170,312.233276 
C225.746475,319.046021 226.561935,325.861115 227.420486,332.670807 
C228.240265,339.172974 229.104904,345.669495 230.003815,352.836731 
C230.121567,353.659668 230.185349,353.814392 230.249130,353.969086 
C230.204041,354.459717 230.224045,354.967194 230.102386,355.438049 
C229.617462,357.315002 229.088425,359.180573 228.575729,361.050354 
C226.988968,360.483398 225.061401,360.310730 223.872711,359.283264 
C217.755875,353.996063 211.899506,348.408691 205.820816,343.075867 
C192.779770,331.634979 179.657959,320.286163 166.569778,308.898987 
C164.209778,306.845734 161.820267,304.824951 159.501266,302.726318 
C155.655380,299.245911 153.167114,295.282135 153.845001,289.678558 
C154.153900,287.125122 153.353149,284.437500 152.953827,281.152466 
C152.851959,280.494171 152.656448,280.044586 152.656448,280.044586 
C152.730667,279.576447 152.804886,279.108337 152.844559,278.068909 
C152.810013,277.497650 152.614838,277.043854 152.614838,277.043854 
M236.883224,121.631065 
C241.567383,137.359680 246.251526,153.088287 251.285355,169.991058 
C253.000580,164.015701 254.280884,159.401627 255.650421,154.814178 
C259.333527,142.477020 263.117218,130.169174 266.675568,117.796394 
C267.085480,116.371048 266.923492,113.873482 266.005981,113.126030 
C261.180267,109.195000 256.026489,105.666710 250.880219,101.921143 
C248.482925,103.948479 246.046951,106.172623 243.437500,108.170135 
C240.704926,110.261902 237.805740,112.136017 234.851624,114.194275 
C235.482010,116.454407 236.093521,118.646881 236.883224,121.631065 
z"/>
  <path fill="#FBFBFB" opacity="1.000000" stroke="none"
    d="
M125.392578,219.936600 
C125.319756,222.351364 125.246941,224.766129 125.178589,227.974380 
C125.252151,229.491318 125.321228,230.214767 125.390305,230.938217 
C125.163750,232.732712 124.937195,234.527206 124.710197,236.321625 
C115.926254,237.689346 108.792381,231.846039 108.199570,222.355011 
C107.795456,215.884979 107.995125,209.377243 107.888893,202.190643 
C107.852966,201.494904 107.644142,201.043671 107.644142,201.043671 
C108.128395,187.758804 108.579613,174.472610 109.105713,161.189407 
C109.688721,146.469086 113.666779,132.485199 118.787926,118.820320 
C123.700401,105.712265 130.471008,93.557297 138.348221,81.972664 
C139.754517,79.904510 140.074921,76.884331 140.282120,74.255295 
C140.861130,66.908592 144.348190,61.241936 149.501205,56.239777 
C168.102234,38.183300 189.581390,25.211582 214.889709,18.972660 
C258.464355,8.230787 298.751617,15.703630 335.371552,41.552929 
C343.122772,47.024349 350.114319,53.767845 356.629913,60.701405 
C359.394531,63.643341 360.949310,68.490341 361.383392,72.646027 
C361.852020,77.131973 363.074036,80.754425 365.623322,84.413719 
C380.709076,106.068008 390.330963,129.853867 392.973267,156.273544 
C393.303192,159.572388 393.754059,162.859131 394.153076,166.894440 
C394.416656,168.147858 394.676056,168.658356 394.935425,169.168839 
C394.910492,183.277893 394.940369,197.387405 394.827606,211.495758 
C394.793274,215.793610 394.577454,220.113480 394.069550,224.378586 
C393.307159,230.780670 384.944794,238.916290 376.793060,235.950775 
C376.793060,213.930801 376.793060,191.404449 376.789368,168.185654 
C376.785675,167.493195 376.536987,167.068314 376.536987,167.068314 
C374.836456,156.186401 373.990265,145.081894 371.227325,134.476776 
C367.452759,119.988724 360.338531,106.802322 351.265808,94.847237 
C349.636230,92.699928 346.739288,90.680763 344.158295,90.262123 
C338.732300,89.382019 334.663361,86.664726 330.978790,83.022209 
C315.007874,67.233559 296.539581,55.805447 274.279449,51.512398 
C238.396408,44.592060 206.369019,52.858696 178.540115,76.758568 
C174.667084,80.084793 171.061783,83.805336 166.852905,86.628212 
C164.153778,88.438507 160.521790,88.806503 157.410751,90.073364 
C155.545792,90.832802 153.283997,91.656631 152.212112,93.168640 
C136.366547,115.520470 126.425575,139.995468 125.923363,167.786652 
C125.848755,171.915527 125.456985,176.038681 125.233459,180.832504 
C125.254974,181.500534 125.453331,181.939026 125.453323,181.939026 
C125.360504,182.725555 125.267685,183.512070 125.184982,185.060028 
C125.270027,186.858261 125.344948,187.895050 125.419876,188.931839 
C125.353363,197.669891 125.286858,206.407928 125.200104,215.983368 
C125.250771,217.859375 125.321678,218.897995 125.392578,219.936600 
z"/>
  <path fill="#FBFAFA" opacity="1.000000" stroke="none"
    d="
M276.048615,487.355347 
C275.265411,487.305481 274.482239,487.255615 273.013611,487.175659 
C271.903198,487.209045 271.478210,487.272491 271.053253,487.335938 
C270.580139,487.265076 270.106995,487.194214 268.876129,487.129150 
C266.436707,487.217163 264.755005,487.299377 263.073334,487.381653 
C262.594421,487.322113 262.115479,487.262573 260.935913,487.171692 
C259.513611,487.220917 258.791931,487.301453 258.070251,487.382019 
C256.899475,486.093323 254.711990,484.806641 254.709381,483.515533 
C254.665237,461.810974 254.892197,440.105896 255.067978,418.400970 
C255.073090,417.768646 255.176758,417.137115 255.295044,415.841705 
C263.321808,415.841705 271.225342,415.841705 279.812347,415.837952 
C280.495850,415.834198 280.961090,415.676788 280.961090,415.676788 
C292.373230,416.903229 303.558044,418.996796 310.775970,429.098938 
C313.583984,433.029022 315.074890,437.900146 317.208435,442.997498 
C317.392426,444.020599 317.533661,444.388855 317.674896,444.757111 
C317.888550,453.206055 317.849091,461.687744 313.270142,469.185455 
C306.578369,480.142822 296.353607,485.435120 283.798920,486.635284 
C281.813965,486.825043 279.822113,486.942657 277.166718,487.152649 
C276.499969,487.211700 276.048615,487.355347 276.048615,487.355347 
M297.123047,446.028198 
C295.758850,435.434082 287.134918,430.964844 275.299988,433.302368 
C275.299988,445.684021 275.299988,458.034943 275.299988,470.354950 
C291.034729,471.238251 297.522827,465.119507 297.370972,449.902344 
C297.361053,448.906860 297.282074,447.912079 297.123047,446.028198 
z"/>
  <path fill="#FAF9F9" opacity="1.000000" stroke="none"
    d="
M193.053391,487.318359 
C189.591553,487.318390 186.129715,487.318390 181.957932,487.318390 
C181.672440,481.667969 181.185181,476.472626 181.188492,471.277618 
C181.199631,453.827820 181.337143,436.377258 181.628677,418.930420 
C181.645660,417.913849 183.479919,416.033325 184.421707,416.062561 
C195.995758,416.421722 207.782532,415.844238 219.079865,417.898346 
C239.044662,421.528381 246.935745,439.894379 243.874344,457.962219 
C240.821762,475.977844 225.665924,485.738342 209.767609,486.672028 
C205.804169,486.904785 201.831253,486.976135 197.021515,487.128876 
C195.138016,487.196869 194.095703,487.257629 193.053391,487.318359 
M216.528381,434.595856 
C211.628357,433.747345 206.728348,432.898834 201.627533,432.015564 
C201.627533,445.581543 201.627533,457.918121 201.627533,470.215454 
C212.379089,471.352051 220.293533,468.096130 222.716187,460.715729 
C225.264389,452.952911 225.673355,439.929108 216.528381,434.595856 
z"/>
  <path fill="#F9F9F9" opacity="1.000000" stroke="none"
    d="
M350.895294,441.592834 
C356.999817,441.592834 363.104340,441.592834 370.081360,441.592834 
C370.081360,434.853455 370.361206,428.112762 369.981079,421.409454 
C369.735535,417.079712 370.836975,415.384308 375.408783,415.794189 
C379.994476,416.205292 384.645752,415.884521 389.593872,415.884521 
C389.593872,439.662689 389.593872,462.985138 389.593872,486.820312 
C387.956512,486.955688 386.376892,487.086273 383.946533,487.179871 
C381.082001,487.202240 379.068146,487.261627 377.054321,487.321045 
C376.572906,487.292603 376.091492,487.264160 374.964355,487.212280 
C373.896881,487.239166 373.475159,487.289459 373.053436,487.339722 
C369.965546,487.145538 370.009491,484.993347 370.025024,482.700623 
C370.077942,474.904999 370.045258,467.108826 370.045258,459.048462 
C362.717102,459.048462 355.630981,459.048462 347.957703,459.048462 
C347.957703,466.890259 347.808899,474.832275 348.025665,482.764313 
C348.122131,486.294556 347.041992,487.427307 343.455322,487.171509 
C338.553406,486.821838 333.607849,487.084167 328.430481,487.084167 
C328.430481,471.509827 328.469513,456.760681 328.413696,442.011902 
C328.386627,434.858002 328.331604,427.697784 327.996796,420.554108 
C327.818878,416.758575 329.214691,415.608612 332.909668,415.843323 
C337.689667,416.146912 342.503571,415.917389 347.950165,415.917389 
C347.950165,423.245636 347.872986,430.179230 348.009277,437.108643 
C348.039917,438.668762 348.815521,440.214203 349.873474,441.794281 
C350.498779,441.822144 350.895294,441.592834 350.895294,441.592834 
z"/>
  <path fill="#FAF9F9" opacity="1.000000" stroke="none"
    d="
M156.935150,482.034943 
C141.888382,491.047668 127.215103,490.503082 113.376427,480.694855 
C105.605278,475.187042 102.598785,466.536591 101.635284,457.171844 
C100.513634,446.269928 102.050354,436.142303 109.109146,427.274872 
C117.798370,416.359253 129.634232,413.582825 142.487625,415.369690 
C155.458206,417.172852 164.728806,424.804810 168.870453,437.397827 
C174.690445,455.094086 169.967041,472.132233 156.935150,482.034943 
M143.162430,469.854431 
C144.801254,468.251953 147.060516,466.940735 147.972855,464.997192 
C152.205902,455.979584 152.433990,446.682861 147.760223,437.807159 
C145.284470,433.105560 140.532501,431.272522 135.251709,431.590485 
C129.858871,431.915131 125.971779,434.640808 123.718498,439.630585 
C120.402039,446.974701 120.282829,454.458374 123.110229,461.893677 
C126.309258,470.306305 134.175095,473.546326 143.162430,469.854431 
z"/>
  <path fill="#FAF9F9" opacity="1.000000" stroke="none"
    d="
M448.034088,487.298920 
C443.769562,485.967896 444.017914,481.847626 443.260254,478.734192 
C442.197327,474.366425 440.457001,472.361115 435.606323,472.834656 
C430.333160,473.349457 424.970886,472.951477 419.343597,472.951477 
C418.282959,476.051147 416.805817,479.061279 416.278168,482.229553 
C415.562408,486.527130 413.234039,487.475555 409.351654,487.227386 
C405.109222,486.956177 400.836090,487.165680 395.582733,487.165680 
C399.890656,474.539337 403.850372,463.034027 407.740021,451.505066 
C411.636627,439.955383 415.463287,428.382080 419.623138,415.912231 
C425.704742,415.912231 432.807343,415.799744 439.898285,416.035889 
C440.938293,416.070526 442.452209,417.575409 442.855164,418.715210 
C450.577393,440.558380 458.174530,462.445831 465.743958,484.342621 
C465.986847,485.045227 465.661987,485.944061 465.048523,486.951355 
C464.495239,487.151306 464.045959,487.339142 464.045959,487.339142 
C462.621674,487.265259 461.197418,487.191406 458.976624,487.126160 
C457.139648,487.201569 456.099213,487.268372 455.058746,487.335175 
C453.312683,487.255402 451.566620,487.175629 449.160065,487.108765 
C448.499573,487.121643 448.034088,487.298920 448.034088,487.298920 
M431.823975,439.638367 
C431.289856,438.066010 430.755737,436.493622 429.873871,433.897461 
C427.601746,442.032013 425.699127,448.843597 423.717102,455.939514 
C428.085205,455.939514 432.008545,455.939514 436.509338,455.939514 
C434.961639,450.514252 433.517914,445.453552 431.823975,439.638367 
z"/>
  <path fill="#F5F4F5" opacity="1.000000" stroke="none"
    d="
M376.818604,248.040390 
C377.792572,240.164383 384.322601,241.585403 390.442383,240.552460 
C389.286133,246.446579 388.341797,252.222534 387.004761,257.906097 
C381.816772,279.959259 373.354431,300.688202 361.643311,320.100098 
C352.623444,335.051056 341.785004,348.552094 328.735504,360.103058 
C317.085724,370.415039 304.076294,378.800568 289.601990,384.755798 
C286.958893,385.843292 283.944489,386.826141 283.060272,383.249664 
C282.291809,380.141479 280.751740,376.665649 285.329590,373.889465 
C296.579163,367.067230 308.162354,360.453827 318.229034,352.092194 
C340.309723,333.751434 355.753174,310.263062 366.124329,283.619934 
C370.418610,272.588043 373.275513,260.996643 376.849152,249.073441 
C376.912201,248.487183 376.818604,248.040390 376.818604,248.040390 
z"/>
  <path fill="#FAF9F9" opacity="1.000000" stroke="none"
    d="
M40.969421,415.698639 
C42.708897,415.773682 44.448368,415.848755 47.026924,415.920654 
C49.563114,415.841644 51.260216,415.765778 52.957321,415.689911 
C55.823822,415.656860 57.784626,416.554108 59.015392,419.566620 
C62.300022,427.606293 65.967430,435.489563 70.026459,444.664062 
C73.162262,437.070892 75.667015,430.360260 78.714668,423.906036 
C80.176331,420.810638 79.869980,415.871948 85.972298,415.888275 
C87.096481,415.837738 87.528229,415.761536 87.959976,415.685333 
C92.589539,415.685333 97.219101,415.685333 103.181824,415.685333 
C99.647270,422.362671 96.746887,428.020142 93.682404,433.587311 
C89.632950,440.943817 85.081818,448.052704 81.493263,455.622131 
C79.760361,459.277405 79.394867,463.710815 79.019585,467.847229 
C78.540352,473.129425 78.412010,478.479187 78.644882,483.777283 
C78.790550,487.091339 77.052849,487.210327 73.940262,487.177307 
C71.774368,487.223145 70.416496,487.279755 69.058632,487.336365 
C59.078850,486.583130 58.128956,486.473541 59.299782,476.325806 
C60.885872,462.578888 55.382931,451.601379 48.679077,440.616272 
C44.643776,434.003906 40.964054,427.174530 37.125847,420.441925 
C35.696712,417.935089 34.704956,415.627594 39.868305,415.878540 
C40.653904,415.811188 40.811665,415.754913 40.969421,415.698639 
z"/>
  <path fill="#F8F7F7" opacity="1.000000" stroke="none"
    d="
M137.966583,180.750259 
C155.987549,183.667297 159.746567,201.430756 157.449570,214.312012 
C155.189087,226.988464 143.913239,235.492203 130.848602,235.203857 
C127.325264,235.126114 127.463524,232.821564 127.464020,230.427780 
C127.466835,216.858246 127.464981,203.288727 127.464745,189.719193 
C127.464699,187.241089 127.464729,184.763000 127.464729,181.793396 
C129.711639,181.465607 131.957458,181.137970 134.983917,180.805450 
C136.498566,180.783813 137.232574,180.767044 137.966583,180.750259 
z"/>
  <path fill="#F8F8F8" opacity="1.000000" stroke="none"
    d="
M350.709351,187.718994 
C357.879395,181.158447 362.677429,179.905304 374.014282,181.650772 
C374.014282,199.331451 374.014282,217.124619 374.014282,235.063614 
C365.648132,235.221848 358.250214,233.145157 351.652069,228.128708 
C343.132751,221.651596 342.417725,205.042877 346.617493,194.862228 
C347.609406,192.457733 349.208832,190.303879 350.709351,187.718994 
z"/>
  <path fill="#F9F8F9" opacity="1.000000" stroke="none"
    d="
M256.019012,400.158051 
C245.743027,398.581604 239.905884,392.577423 239.380219,383.043121 
C238.907913,374.476532 244.499481,367.252228 253.279526,365.085144 
C263.182159,362.641052 273.065674,369.192230 274.808929,379.648651 
C276.338348,388.822571 269.725983,399.057800 259.000549,399.978760 
C257.504944,400.057159 256.761963,400.107605 256.019012,400.158051 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M377.345093,487.528748 
C379.068146,487.261627 381.082001,487.202240 383.510681,487.263458 
C381.828979,487.501526 379.732422,487.618988 377.345093,487.528748 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M7.413047,492.974457 
C8.259959,493.830841 8.885415,494.512787 9.510871,495.194702 
C9.262254,495.437195 9.013636,495.679688 8.765018,495.922180 
C7.973654,494.924286 7.182291,493.926361 6.390920,492.928467 
C6.505909,492.842590 6.613637,492.701691 6.737805,492.685303 
C6.881521,492.666351 7.039694,492.756958 7.413047,492.974457 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M52.677513,415.483337 
C51.260216,415.765778 49.563114,415.841644 47.451546,415.816589 
C48.823956,415.569366 50.610832,415.423035 52.677513,415.483337 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M240.354172,185.874084 
C240.931396,187.130463 241.106552,188.429901 241.281708,189.729324 
C240.994751,189.795532 240.707794,189.861740 240.420837,189.927948 
C239.996140,188.862564 239.571426,187.797180 239.146973,186.363739 
C239.415497,185.969482 239.683807,185.943298 240.354172,185.874084 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M263.357117,487.572296 
C264.755005,487.299377 266.436707,487.217163 268.529205,487.235291 
C267.173645,487.478088 265.407288,487.620544 263.357117,487.572296 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M262.665833,186.858398 
C262.344360,188.084473 261.822113,189.182877 261.299866,190.281296 
C260.891998,190.096848 260.484131,189.912399 260.076233,189.727951 
C260.523865,188.603836 260.971497,187.479721 261.694885,186.142059 
C262.059509,186.242722 262.224304,186.510117 262.665833,186.858398 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M69.314018,487.531738 
C70.416496,487.279755 71.774368,487.223145 73.520248,487.296021 
C72.461975,487.526031 71.015694,487.626556 69.314018,487.531738 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M497.176178,490.626709 
C497.081909,489.880890 497.244415,489.097473 497.406921,488.314026 
C497.665985,488.398285 497.925018,488.482544 498.184082,488.566772 
C497.933716,489.240906 497.683319,489.915009 497.176178,490.626709 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M193.286255,487.512878 
C194.095703,487.257629 195.138016,487.196869 196.560577,487.236450 
C195.800262,487.460297 194.659683,487.583862 193.286255,487.512878 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M125.590500,188.689148 
C125.344948,187.895050 125.270027,186.858261 125.300552,185.443054 
C125.524376,186.191895 125.642746,187.319183 125.590500,188.689148 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M455.293365,487.526245 
C456.099213,487.268372 457.139648,487.201569 458.560425,487.234619 
C457.803162,487.462067 456.665588,487.589661 455.293365,487.526245 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M125.569252,219.698227 
C125.321678,218.897995 125.250771,217.859375 125.300690,216.446777 
C125.529655,217.201813 125.637794,218.330826 125.569252,219.698227 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M258.273499,487.554596 
C258.791931,487.301453 259.513611,487.220917 260.582336,487.261169 
C260.111816,487.497040 259.294250,487.612091 258.273499,487.554596 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M493.342194,495.798584 
C493.048187,496.139343 492.806549,496.270599 492.564880,496.401855 
C492.492859,496.152039 492.420837,495.902283 492.348785,495.652466 
C492.697388,495.631317 493.045959,495.610199 493.342194,495.798584 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M174.370361,216.000854 
C174.892731,215.800980 175.776871,215.601944 176.780930,215.701126 
C176.177933,216.000137 175.455032,216.000931 174.370361,216.000854 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M256.213531,400.376343 
C256.761963,400.107605 257.504944,400.057159 258.614563,400.081604 
C258.123505,400.302551 257.265778,400.448608 256.213531,400.376343 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M125.560226,230.732086 
C125.321228,230.214767 125.252151,229.491318 125.287094,228.415497 
C125.504135,228.884064 125.617142,229.705017 125.560226,230.732086 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M137.775879,180.551971 
C137.232574,180.767044 136.498566,180.783813 135.409821,180.704880 
C135.898453,180.524002 136.741806,180.438843 137.775879,180.551971 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M349.474487,281.654816 
C349.229462,280.924927 349.219238,279.882690 349.451080,278.528625 
C349.698517,279.258667 349.703888,280.300568 349.474487,281.654816 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M494.741638,493.355713 
C494.991577,493.370300 495.128052,493.505035 495.264526,493.639771 
C495.052399,493.585144 494.840302,493.530518 494.741638,493.355713 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M394.947144,168.880920 
C394.676056,168.658356 394.416656,168.147858 394.249969,167.339401 
C394.548065,167.558624 394.753448,168.075821 394.947144,168.880920 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M238.031860,177.174316 
C238.294601,177.393341 238.551285,177.888947 238.713013,178.664246 
C238.420624,178.446274 238.223190,177.948593 238.031860,177.174316 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M87.802536,415.516541 
C87.528229,415.761536 87.096481,415.837738 86.353981,415.792419 
C86.577179,415.563171 87.111137,415.455475 87.802536,415.516541 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M271.203674,487.500488 
C271.478210,487.272491 271.903198,487.209045 272.626465,487.277100 
C272.401215,487.494080 271.877655,487.579529 271.203674,487.500488 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M373.200470,487.502502 
C373.475159,487.289459 373.896881,487.239166 374.612305,487.322876 
C374.386505,487.526337 373.867004,487.595795 373.200470,487.502502 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M263.587524,254.719727 
C263.432892,254.362793 263.441406,253.786087 263.703796,253.048096 
C263.888672,253.424530 263.819672,253.962234 263.587524,254.719727 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M448.127075,487.423126 
C448.034088,487.298920 448.499573,487.121643 448.732880,487.208496 
C448.966187,487.295319 448.642731,487.608398 448.642731,487.608398 
C448.642731,487.608398 448.220093,487.547333 448.127075,487.423126 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M165.541901,204.131195 
C165.724258,204.191330 165.788925,204.345566 165.757233,204.731384 
C165.346680,204.776810 165.267776,204.530930 165.541901,204.131195 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M276.140015,487.471130 
C276.048615,487.355347 276.499969,487.211700 276.725891,487.282135 
C276.951782,487.352570 276.636719,487.642761 276.636719,487.642761 
C276.636719,487.642761 276.231415,487.586884 276.140015,487.471130 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M107.529221,201.142807 
C107.644142,201.043671 107.852966,201.494904 107.777596,201.731735 
C107.373863,201.801025 107.277885,201.558823 107.529221,201.142807 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M376.680084,248.104645 
C376.818604,248.040390 376.912201,248.487183 376.789795,248.677979 
C376.667389,248.868790 376.388031,248.551132 376.388031,248.551132 
C376.388031,248.551132 376.541565,248.168884 376.680084,248.104645 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M125.552589,181.844727 
C125.453331,181.939026 125.254974,181.500534 125.348328,181.278793 
C125.708572,181.239380 125.778625,181.470505 125.552589,181.844727 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M464.151001,487.455963 
C464.045959,487.339142 464.495239,487.151306 464.736511,487.183472 
C464.833282,487.572632 464.592682,487.691681 464.151001,487.455963 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M376.439880,167.167435 
C376.536987,167.068314 376.785675,167.493195 376.695740,167.722229 
C376.321014,167.786530 376.233337,167.558304 376.439880,167.167435 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M147.245255,243.541443 
C147.433380,243.602661 147.574188,243.971832 147.701172,244.649353 
C147.524216,244.588257 147.361084,244.218826 147.245255,243.541443 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M238.263535,250.537140 
C238.482361,250.610336 238.641663,250.976761 238.692429,251.639862 
C238.457260,251.567810 238.330643,251.199081 238.263535,250.537140 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M317.740540,444.470245 
C317.533661,444.388855 317.392426,444.020599 317.366028,443.365723 
C317.589294,443.447205 317.697754,443.815277 317.740540,444.470245 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M350.819519,441.482941 
C350.895294,441.592834 350.498779,441.822144 350.301208,441.708069 
C350.253510,441.305664 350.466888,441.231995 350.819519,441.482941 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M353.463806,253.724228 
C353.272461,253.552124 353.263672,253.137268 353.492737,252.503372 
C353.702545,252.683380 353.674438,253.082428 353.463806,253.724228 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M351.512604,264.803741 
C351.397797,264.657288 351.439636,264.353180 351.704102,263.927673 
C351.927887,264.112854 351.842041,264.392792 351.512604,264.803741 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M152.504486,277.140808 
C152.614838,277.043854 152.810013,277.497650 152.724609,277.729370 
C152.335907,277.780609 152.254211,277.539520 152.504486,277.140808 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M152.540192,280.149292 
C152.656448,280.044586 152.851959,280.494171 152.811981,280.735962 
C152.419098,280.829437 152.303070,280.588165 152.540192,280.149292 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M224.889069,312.010468 
C224.678711,311.998627 224.445221,311.764008 224.299347,311.287476 
C224.629059,311.239685 224.788712,311.487061 224.889069,312.010468 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M277.470215,313.212677 
C277.598328,313.360321 277.573334,313.676056 277.322021,314.121735 
C277.079254,313.938446 277.153015,313.648102 277.470215,313.212677 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M230.380371,353.870239 
C230.185349,353.814392 230.121567,353.659668 230.118057,353.261414 
C230.555206,353.176575 230.666306,353.427765 230.380371,353.870239 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M40.879196,415.574829 
C40.811665,415.754913 40.653904,415.811188 40.266674,415.765259 
C40.234592,415.346344 40.485184,415.275635 40.879196,415.574829 
z"/>
  <path fill="#010101" opacity="1.000000" stroke="none"
    d="
M280.873962,415.556061 
C280.961090,415.676788 280.495850,415.834198 280.273193,415.731079 
C280.247894,415.325623 280.493347,415.261414 280.873962,415.556061 
z"/>
  <path fill="#040404" opacity="1.000000" stroke="none"
    d="
M236.794128,121.235214 
C236.093521,118.646881 235.482010,116.454407 234.851624,114.194275 
C237.805740,112.136017 240.704926,110.261902 243.437500,108.170135 
C246.046951,106.172623 248.482925,103.948479 250.880219,101.921143 
C256.026489,105.666710 261.180267,109.195000 266.005981,113.126030 
C266.923492,113.873482 267.085480,116.371048 266.675568,117.796394 
C263.117218,130.169174 259.333527,142.477020 255.650421,154.814178 
C254.280884,159.401627 253.000580,164.015701 251.285355,169.991058 
C246.251526,153.088287 241.567383,137.359680 236.794128,121.235214 
z"/>
  <path fill="#030303" opacity="1.000000" stroke="none"
    d="
M297.179138,446.472595 
C297.282074,447.912079 297.361053,448.906860 297.370972,449.902344 
C297.522827,465.119507 291.034729,471.238251 275.299988,470.354950 
C275.299988,458.034943 275.299988,445.684021 275.299988,433.302368 
C287.134918,430.964844 295.758850,435.434082 297.179138,446.472595 
z"/>
  <path fill="#080808" opacity="1.000000" stroke="none"
    d="
M216.859131,434.801117 
C225.673355,439.929108 225.264389,452.952911 222.716187,460.715729 
C220.293533,468.096130 212.379089,471.352051 201.627533,470.215454 
C201.627533,457.918121 201.627533,445.581543 201.627533,432.015564 
C206.728348,432.898834 211.628357,433.747345 216.859131,434.801117 
z"/>
  <path fill="#040404" opacity="1.000000" stroke="none"
    d="
M142.816711,470.012451 
C134.175095,473.546326 126.309258,470.306305 123.110229,461.893677 
C120.282829,454.458374 120.402039,446.974701 123.718498,439.630585 
C125.971779,434.640808 129.858871,431.915131 135.251709,431.590485 
C140.532501,431.272522 145.284470,433.105560 147.760223,437.807159 
C152.433990,446.682861 152.205902,455.979584 147.972855,464.997192 
C147.060516,466.940735 144.801254,468.251953 142.816711,470.012451 
z"/>
  <path fill="#0B0B0B" opacity="1.000000" stroke="none"
    d="
M431.949097,440.015625 
C433.517914,445.453552 434.961639,450.514252 436.509338,455.939514 
C432.008545,455.939514 428.085205,455.939514 423.717102,455.939514 
C425.699127,448.843597 427.601746,442.032013 429.873871,433.897461 
C430.755737,436.493622 431.289856,438.066010 431.949097,440.015625 
z"/>
</svg>
)

export const ChatWorkspace = () => (
  <svg width={30} height={30} viewBox='0 0 30 30'>
    <path d='M15 0A15 15 0 110 15 15 15 0 0115 0z' fill='transparent' />
    <path
      className={styles.fillC}
      d='M21.06 8.515a.758.758 0 01.758.758v9.091a.758.758 0 01-.758.758h-7.132a.757.757 0 00-.536.222l-2.181 2.18v-1.645a.758.758 0 00-.758-.758H8.939a.758.758 0 01-.758-.758v-9.09a.758.758 0 01.758-.758zM8.939 7a2.273 2.273 0 00-2.273 2.273v9.091a2.273 2.273 0 002.273 2.273h.757v3.631a.379.379 0 00.647.267l3.9-3.9h6.818a2.273 2.273 0 002.273-2.273V9.273A2.273 2.273 0 0021.06 7z'
    />
  </svg>
)

export const AllConversation = () => (
  <svg width='30' height='30' viewBox='0 0 30 30'>
    <defs>
      <style>
        {
          '.ac-a,.ac-c,.ac-d{fill:#b3b3b3;}.ac-a{stroke:#707070;}.ac-b{fill:rgba(75,75,75,0);}.ac-c{opacity:0;}.ac-e{clip-path:url(#a);}'
        }
      </style>
      <clipPath id='a'>
        <path
          className='ac-a'
          d='M9.5,9V2H0V0H12V9Z'
          transform='translate(-14232 -16931)'
        />
      </clipPath>
    </defs>
    <circle className='ac-b' cx='15' cy='15' r='15' />
    <rect className='ac-c' width='18' height='18' transform='translate(6 6)' />
    <path
      className={styles.fillC}
      d='M9.457,7a.5.5,0,0,1,.5.5v5.973a.5.5,0,0,1-.5.5H4.771a.5.5,0,0,0-.352.146L2.986,15.542V14.462a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5V7.493a.5.5,0,0,1,.5-.5ZM1.493,6A1.493,1.493,0,0,0,0,7.493v5.973a1.493,1.493,0,0,0,1.493,1.493h.5v2.386a.249.249,0,0,0,.425.176l2.561-2.561h4.48a1.493,1.493,0,0,0,1.493-1.493V7.493A1.493,1.493,0,0,0,9.457,6Z'
      transform='translate(6.524 6.215)'
    />
    <g className='ac-e' transform='translate(14241 16940.191)'>
      <path
        className={styles.fillC}
        d='M9.457,7a.5.5,0,0,1,.5.5v5.973a.5.5,0,0,1-.5.5H4.771a.5.5,0,0,0-.352.146L2.986,15.542V14.462a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5V7.493a.5.5,0,0,1,.5-.5ZM1.493,6A1.493,1.493,0,0,0,0,7.493v5.973a1.493,1.493,0,0,0,1.493,1.493h.5v2.386a.249.249,0,0,0,.425.176l2.561-2.561h4.48a1.493,1.493,0,0,0,1.493-1.493V7.493A1.493,1.493,0,0,0,9.457,6Z'
        transform='translate(-14231.476 -16936.975)'
      />
    </g>
    <g className='ac-e' transform='translate(14244 16937.191)'>
      <path
        className={styles.fillC}
        d='M9.457,7a.5.5,0,0,1,.5.5v5.973a.5.5,0,0,1-.5.5H4.771a.5.5,0,0,0-.352.146L2.986,15.542V14.462a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5V7.493a.5.5,0,0,1,.5-.5ZM1.493,6A1.493,1.493,0,0,0,0,7.493v5.973a1.493,1.493,0,0,0,1.493,1.493h.5v2.386a.249.249,0,0,0,.425.176l2.561-2.561h4.48a1.493,1.493,0,0,0,1.493-1.493V7.493A1.493,1.493,0,0,0,9.457,6Z'
        transform='translate(-14231.476 -16936.975)'
      />
    </g>
  </svg>
)
export const HelpIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={30}
    height={30}
    viewBox='0 0 30 30'
  >
    <path
      className={styles.fillC}
      d='M16.091 18.966a.917.917 0 01-.977 1.008.931.931 0 01-.978-1.008.978.978 0 011.955-.029v.029zM14.977 10a4.616 4.616 0 00-2.259.536c-.059.031-.059.092-.059.153v1.486a.075.075 0 00.119.061 3.692 3.692 0 011.872-.5c.906 0 1.263.383 1.263.934 0 .475-.283.8-.773 1.3-.713.73-1.14 1.191-1.14 1.912a1.709 1.709 0 00.357 1.057.244.244 0 00.188.061h1.293a.065.065 0 00.059-.107 1.651 1.651 0 01-.238-.843c0-.459.55-.964 1.13-1.531a2.737 2.737 0 00.951-2.113c0-1.348-.98-2.406-2.763-2.406zm8.523 5A8.5 8.5 0 1115 6.5a8.5 8.5 0 018.5 8.5zm-1.825 0A6.675 6.675 0 1015 21.675 6.675 6.675 0 0021.675 15z'
    />
  </svg>
)

export const LogIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
    
    <rect id="Canvas" fill={styles.fillC} opacity="0" width="18" height="18" /><path className={styles.fillC} d="M16.5,12h-1a.5.5,0,0,0-.5.5V15H3V12.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-4A.5.5,0,0,0,16.5,12Z" />
    <path  className={styles.fillC} d="M8.8245,13.428a.25.25,0,0,0,.35,0L12.9,9.6655a.391.391,0,0,0,.1-.263.4.4,0,0,0-.4-.4H10V1.5A.5.5,0,0,0,9.5,1h-1a.5.5,0,0,0-.5.5V9H5.4a.4.4,0,0,0-.4.4.391.391,0,0,0,.1.263Z" />
  </svg>
)

export const CCPLogIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18" fill='#b3b3b3'>
    <rect id="Canvas" fill="blue" opacity="0" width="18" height="18" /><ellipse cx="9" cy="3.5" rx="8" ry="2.5" />
    <path d="M5.3885,12.5895a1.211,1.211,0,0,1-.314-.8C3.2305,11.478,1.509,10.942,1,10.135V14.5C1,15.8805,4.582,17,9,17c.1385,0,.2735-.0045.4105-.0065Z" />
    <path d="M16.5,6.5V9.3635A1.18,1.18,0,0,0,17,8.5V5.135A5.06144,5.06144,0,0,1,14.3855,6.5Z" />
    <path d="M6.315,10.5H8.5V7.13C5.953,7.059,1.8365,6.4625,1,5.135V8.5c0,.996,1.868,1.8535,4.565,2.255A1.21847,1.21847,0,0,1,6.315,10.5Z" />
    <path d="M17.573,12.427A.25.25,0,0,0,17.3965,12H15V8H10v4H7.6035a.25.25,0,0,0-.1765.427L12.5,18Z" />
  </svg>
)

export const DarkMode = () => (
  <svg width={18} height={18} viewBox='0 0 18 18'>
    <defs>
      <style>{'.dm-a{fill:none;}.dm-b{fill:#6e6e6e;}'}</style>
    </defs>
    <rect className='dm-a' width='18' height='18' />
    <path
      className='dm-b'
      d='M7,14a7,7,0,1,1,7-7A7.008,7.008,0,0,1,7,14ZM7,1V13A6,6,0,1,0,7,1Z'
      transform='translate(2 2)'
    />
  </svg>
)

export const Sound = () => (
  <svg width={18} height={18} viewBox='0 0 18 18'>
    <defs>
      <style>{'.so-a,.so-b{fill:#6e6e6e;}.so-a{opacity:0;}'}</style>
    </defs>
    <rect className='so-a' width='18' height='18' />
    <path
      className='so-b'
      d='M3.372,6.036H.5a.5.5,0,0,0-.5.5V11.5a.5.5,0,0,0,.5.5H3.372a.714.714,0,0,1,.466.173L7.4,15.8a.363.363,0,0,0,.6-.288V2.5a.363.363,0,0,0-.6-.286L3.839,5.865a.72.72,0,0,1-.467.172Z'
    />
    <path
      className='so-b'
      d='M11.02,9a3.468,3.468,0,0,1-.7,2.1.49.49,0,0,0,.043.644l.008.008a.5.5,0,0,0,.743-.045A4.478,4.478,0,0,0,11.1,6.277a.5.5,0,0,0-.742-.044l-.007.008a.491.491,0,0,0-.042.646A3.472,3.472,0,0,1,11.02,9Z'
    />
    <path
      className='so-b'
      d='M14.02,9a6.469,6.469,0,0,1-1.558,4.218.486.486,0,0,0,.031.658l.007.007a.5.5,0,0,0,.707,0l.03-.033a7.49,7.49,0,0,0-.013-9.714.5.5,0,0,0-.7-.061l-.03.027-.007.008a.488.488,0,0,0-.033.66A6.468,6.468,0,0,1,14.02,9Z'
    />
  </svg>
)

export const Profile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 0 18 18" width={24}>
    <defs>
      <style>
        {`.profile-nav-a { fill: #b3b3b3;}`}
      </style>
    </defs>
    <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path className="profile-nav-a" d="M9,.5A8.5,8.5,0,1,0,17.5,9,8.5,8.5,0,0,0,9,.5Zm5.491,13.59161a5.41289,5.41289,0,0,0-3.11213-1.56415.65361.65361,0,0,1-.5655-.65569V10.9256a.65656.65656,0,0,1,.16645-.42218A4.99536,4.99536,0,0,0,12.12006,7.3855c0-2.36029-1.25416-3.67963-3.14337-3.67963s-3.179,1.36835-3.179,3.67963A5.05147,5.05147,0,0,0,6.9892,10.5047a.655.655,0,0,1,.16656.42206v.94165a.64978.64978,0,0,1-.57006.65539,5.43158,5.43158,0,0,0-3.11963,1.5205,7.49965,7.49965,0,1,1,11.025.04731Z" />
  </svg>
)


export const TranslateIcon = () => (
  <svg id="button_-_translate" data-name="button - translate" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_150939" data-name="Rectangle 150939" width="18.642" height="18.467" fill="#b3b3b3"/>
    </clipPath>
  </defs>
  <path className={styles.fillC} id="Path_84231" data-name="Path 84231" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#1473e6" opacity="0"/>
  <g id="Group_161790" data-name="Group 161790" transform="translate(5.68 5.768)">
    <path className={styles.fillC} id="Path_84289" data-name="Path 84289" d="M17.425,5H7.071V15.354H17.425Zm-1.294,9.06H8.365V6.294h7.765Z" transform="translate(-6.81 -4.815)" fill="#b3b3b3"/>
    <path className={styles.fillC} id="Path_84290" data-name="Path 84290" d="M61.385,62.677h2.846l.518,1.294h1.294L63.456,57.5H62.161l-2.588,6.471h1.294Zm1.423-3.559.906,2.265H61.9Z" transform="translate(-57.37 -55.374)" fill="#b3b3b3"/>
    <path className={styles.fillC} id="Path_84291" data-name="Path 84291" d="M220.949,216.294h5.177v7.765h-7.765v-5.177h-1.294v6.471H227.42V215h-6.471Z" transform="translate(-209.04 -207.05)" fill="#b3b3b3"/>
    <g id="Group_161789" data-name="Group 161789">
      <g id="Group_161788" data-name="Group 161788" clipPath="url(#clip-path)">
        <path className={styles.fillC} id="Path_84292" data-name="Path 84292" d="M272.155,267.5v1.294h-2.588v1.294h1.33a4.293,4.293,0,0,0,.864,2.193,5.743,5.743,0,0,1-2.194.4v1.294a6.3,6.3,0,0,0,3.236-.77,6.3,6.3,0,0,0,3.236.77v-1.294a5.743,5.743,0,0,1-2.194-.4,4.294,4.294,0,0,0,.865-2.193h1.33v-1.294H273.45V267.5Zm.647,4.046a2.664,2.664,0,0,1-.6-1.457h1.206a2.664,2.664,0,0,1-.6,1.457" transform="translate(-259.599 -257.608)" fill="#b3b3b3"/>
        <path className={styles.fillC} id="Path_84293" data-name="Path 84293" d="M2.693,361.441v-2.31l.833.835.131.131.131-.131.456-.456.131-.131-.131-.131-1.925-1.925-.131-.131-.131.131L.131,359.25,0,359.381l.131.131.456.456.131.131.131-.131.833-.835v3.321H5.9v-1.011H2.693Z" transform="translate(0 -343.986)" fill="#b3b3b3"/>
        <path className={styles.fillC} id="Path_84294" data-name="Path 84294" d="M350.336,2.942l-.456-.456-.131-.131-.131.131-.833.835V0h-4.22V1.011h3.208v2.31l-.833-.835-.131-.131-.131.131-.456.456-.131.131.131.131,1.925,1.925.131.131.131-.131L350.336,3.2l.131-.131Z" transform="translate(-331.825)" fill="#b3b3b3"/>
      </g>
    </g>
  </g>
</svg>
)
